/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, ExtendContainerProps, getProp, CanBeSignal} from '@gongxigames/framework/core/fragments/BuilderY';
import {$AutoplayToggleInput} from './$AutoplayToggleInput';

type AutoplayLimitsSelectorEntryProps = {
    value: CanBeSignal<number | null>;
    action: CanBeSignal<(value: number | null) => void>;
};

export type $AutoplayLimitsSelectorProps = ExtendContainerProps<{
    hidden: boolean;
}> & {
    singleWin: AutoplayLimitsSelectorEntryProps;
    winLimit: AutoplayLimitsSelectorEntryProps;
    lossLimit: AutoplayLimitsSelectorEntryProps;
};

export const $AutoplayLimitsSelector: FC<$AutoplayLimitsSelectorProps> = (props) => {
    if (getProp(props.hidden)) {
        return undefined;
    }

    const {responsive, singleWin, winLimit, lossLimit} = props;

    return <$Container
        responsive={responsive}
        scale={0.74}
    >
        <$AutoplayToggleInput
            name='singleWin'
            position={[0, 0]}
            value={singleWin.value}
            action={singleWin.action}
        />
        <$AutoplayToggleInput
            name='winLimit'
            position={[0, 135]}
            value={winLimit.value}
            action={winLimit.action}
        />
        <$AutoplayToggleInput
            name='lossLimit'
            position={[0, 2 * 135]}
            value={lossLimit.value}
            action={lossLimit.action}
        />
    </$Container>;
};